import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
interface RankNumberProps {
  rank: number;
  // 상위 3위 보라 강조. 실제 랭킹이 아닌 단순 순번을 보여주는 화면은 꺼야 한다.
  highlightTopRanks?: boolean;
}
const bebasStyle = {
  fontFamily: "var(--font-bebas-neue), sans-serif"
} as CSSProperties;
const RankNumber = t0 => {
  const $ = _c(4);
  const {
    rank,
    highlightTopRanks: t1
  } = t0;
  const highlightTopRanks = t1 === undefined ? true : t1;
  const isTopThree = highlightTopRanks && rank <= 3;
  const t2 = `fs text-center font-normal leading-none tracking-[0.21px] ${isTopThree ? "text-[#3F007F]" : "text-[#3A3A42]"}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ...bebasStyle,
      "--fs": 24,
      "--lh": 24
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== rank || $[2] !== t2) {
    t4 = <span className={t2} style={t3 as CSSProperties}>{rank}</span>;
    $[1] = rank;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export default RankNumber;